import countries from 'components/Common/Addressing/CountryAutocomplete/countries'

export default (value, args) => {
  return countries['en'].find(country => country.value === value) !== undefined
}
